import { init as initSentry } from '@sentry/react';

initSentry({
    dsn: __SENTRY_DSN__,
    environment: typeof window !== 'undefined' && window.location?.hostname,
    sampleRate: 1, // One percent of errors, for now
});
